/**
 * Luli For Babies — previsão de entrega (réplica do DeliveryEstimate do site Lovable).
 *
 * Regra idêntica à do site antigo: hoje + N dias úteis (mín.) e hoje + M dias úteis
 * (máx.), pulando sábado e domingo. Feriados não são considerados — igual ao original.
 *
 * Calculado no navegador de propósito: usa a data do próprio cliente e não corre o
 * risco de congelar numa data velha no cache de página da Shopify.
 */
class LuliDelivery extends HTMLElement {
  connectedCallback() {
    const min = parseInt(this.dataset.minDays || '3', 10);
    const max = parseInt(this.dataset.maxDays || '8', 10);
    const today = new Date();

    const minDate = this.addBusinessDays(today, min);
    const maxDate = this.addBusinessDays(today, max);

    const minEl = this.querySelector('[ref="min"]');
    const maxEl = this.querySelector('[ref="max"]');
    if (!minEl || !maxEl) return;

    minEl.textContent = this.format(minDate);
    maxEl.textContent = this.format(maxDate);
    this.hidden = false;
  }

  /**
   * Soma dias úteis a uma data, pulando fim de semana.
   * @param {Date} start
   * @param {number} days
   * @returns {Date}
   */
  addBusinessDays(start, days) {
    const date = new Date(start);
    let added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added++;
    }
    return date;
  }

  /**
   * "21 de jul."
   * @param {Date} date
   * @returns {string}
   */
  format(date) {
    return new Intl.DateTimeFormat('pt-BR', { day: 'numeric', month: 'short' }).format(date);
  }
}

if (!customElements.get('luli-delivery')) {
  customElements.define('luli-delivery', LuliDelivery);
}
